import React, { useState } from 'react';
import { Check, Zap, Users } from 'lucide-react';
import RegistrationForm from '../components/RegistrationForm';
import '../styles/Pricing.css';

const Pricing = () => {
  const [activeTab, setActiveTab] = useState('artist');
  const [selectedPlan, setSelectedPlan] = useState(null);

  const pricingPlans = {
    artist: [
      {
        name: 'Starter Artist',
        price: '$4.99',
        period: 'One-Time Fee',
        features: [
          'Up to 20 tracks or 1 album',
          '1 artist or group',
          'Global distribution',
          'Royalty tracking',
          'YouTube Official Art Tracks'
        ],
        popular: false
      },
      {
        name: 'Pro Artist',
        price: '$14.99',
        period: 'One-Time Fee',
        features: [
          'Unlimited uploads',
          '1 artist or group',
          'Global distribution',
          'Royalty tracking',
          'YouTube Official Art Tracks',
          'Priority processing'
        ],
        popular: true
      }
    ],
    label: [
      {
        name: 'Label Plan',
        price: '$49.99',
        period: 'One-Time Fee',
        features: [
          'Unlimited artists',
          'Unlimited uploads',
          'Centralized label dashboard',
          'Global distribution',
          'Royalty tracking',
          'YouTube Official Art Tracks',
          'Scalable for growth'
        ],
        popular: false
      }
    ]
  };

  const platforms = [
    'Spotify', 'Apple Music', 'Amazon Music', 'Tidal', 'Deezer',
    'YouTube Music', 'Pandora', 'SoundCloud', 'TikTok', 'Instagram',
    'Facebook', 'Snapchat', 'Tencent', 'NetEase', 'Anghami', 'Boomplay'
  ];

  if (selectedPlan) {
    return (
      <div className="pricing-container">
        <RegistrationForm 
          selectedPlan={selectedPlan} 
          onBack={() => setSelectedPlan(null)} 
        />
      </div>
    );
  }

  return (
    <div className="pricing-container">
      <header className="pricing-header">
        <h1>Simple, One-Time Pricing</h1>
        <p>No monthly subscriptions. No annual renewals. Pay once and keep 100% of your royalties.</p>
        
        <div className="pricing-tabs">
          <button 
            className={`tab-btn ${activeTab === 'artist' ? 'active' : ''}`}
            onClick={() => setActiveTab('artist')}
          >
            <Zap size={16} className="icon" />
            <span>For Artists</span>
          </button>
          <button 
            className={`tab-btn ${activeTab === 'label' ? 'active' : ''}`}
            onClick={() => setActiveTab('label')}
          >
            <Users size={16} className="icon" />
            <span>For Labels</span>
          </button>
        </div>
      </header>

      <div className="pricing-plans">
        {pricingPlans[activeTab].map((plan, index) => (
          <div key={index} className={`plan-card ${plan.popular ? 'popular' : ''}`}>
            {plan.popular && <div className="popular-badge">Most Popular</div>}
            <h3>{plan.name}</h3>
            <div className="price">
              <span className="amount">{plan.price}</span>
              <span className="period">{plan.period}</span>
            </div>
            <ul className="features-list">
              {plan.features.map((feature, i) => (
                <li key={i}>
                  <Check className="check-icon" size={18} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <button 
              className="cta-button"
              onClick={() => setSelectedPlan(plan)}
            >
              {plan.price === 'Free' ? 'Get Started' : 'Choose Plan'}
            </button>
          </div>
        ))}
      </div>

      <div className="platforms-section">
        <h2>Distribute Everywhere</h2>
        <p>We deliver your music to all major platforms and stores worldwide</p>
        <div className="platforms-grid">
          {platforms.map((platform, i) => (
            <div key={i} className="platform-tag">
              {platform}
            </div>
          ))}
        </div>
      </div>

      <div className="pricing-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-item">
          <h4>Is there a contract or long-term commitment?</h4>
          <p>No, you can cancel your Pro Artist plan anytime. The free plan remains free forever.</p>
        </div>
        <div className="faq-item">
          <h4>How do payouts work?</h4>
          <p>We issue payouts when your balance reaches $100. Payments are made via bank transfer, PayPal, or other supported methods.</p>
        </div>
        <div className="faq-item">
          <h4>Can I upgrade or downgrade my plan?</h4>
          <p>Yes, you can change your plan at any time. Changes will take effect at the start of your next billing cycle.</p>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
